// Fetch runtime config (google_client_id, env label) once at app boot.
import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import { api } from "./api";

interface ClientConfig {
  env: string;
  google_client_id: string | null;
  billing?: {
    stripe_enabled: boolean;
    razorpay_enabled: boolean;
  };
}

const DEFAULT: ClientConfig = {
  env: "unknown",
  google_client_id: null,
  billing: { stripe_enabled: false, razorpay_enabled: false },
};

const Ctx = createContext<ClientConfig | null>(null);

export function ConfigProvider({ children }: { children: ReactNode }) {
  const [cfg, setCfg] = useState<ClientConfig | null>(null);

  useEffect(() => {
    let cancel = false;
    api.get<ClientConfig>("/api/config", { auth: false })
      .then((c) => { if (!cancel) setCfg(c); })
      .catch(() => { if (!cancel) setCfg(DEFAULT); });
    return () => { cancel = true; };
  }, []);

  return <Ctx.Provider value={cfg}>{children}</Ctx.Provider>;
}

export function useConfig(): ClientConfig | null {
  return useContext(Ctx);
}
